// removed by extract-text-webpack-plugin
module.exports = {"blog":"styles-module__blog____9Tei styles-module__container___3efux","postList":"styles-module__postList___2wB1P"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/containers/Blog/styles.module.css
// module id = 31
// module chunks = 0